import * as types from './invoices.types';

export const invoicesPageSelectors: types.IInvoicesPageSelectors = {
  selectInvoiceIds: (state) => state.page.invoices.invoiceIds,
  selectInvoicesPage: (state) => state.page.invoices.page,
  selectInvoicesLimit: (state) => state.page.invoices.limit,
  selectInvoicesTotal: (state) => state.page.invoices.total,
  selectInvoicesTotalPages: (state) => state.page.invoices.totalPages,
};
